var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"IntersectionRef"},[(_vm.isVisible)?_vm._t("default"):_vm._t("placeholder")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }